<template>
 <b-container>
     
     <!--<a href="#" v-scroll-to="'#element'">Scroll to #element</a>-->
     <div v-if="createRequestVisable"> 
     <b-row>
      <b-col md="12" class="my-1">
      <b>Select Type of Leave</b>
      <select class="form-control" id="id_Employee" name="Employee" style="overflow:scroll;" v-model="typeOfLeave" @change="leaveTypeChanged()">
                        <option  selected value="Annual Leave">Annual Leave</option>
                        <option   value="Sick leave">Sick leave</option>
                        <option   value="Family Responsibility leave">Family Responsibility leave</option>
                        <option   value="Maternity / Paternity leave">Maternity / Paternity leave</option>
                        <option   value="Unpaid leave">Unpaid leave</option>
                        <option   value="In Lieu">In Lieu</option>
                        <option   value="Other">Other</option>
					</select>  
      </b-col>
     
    </b-row>
    <b-row v-if="leaveDescRequired">
      <b-col md="12" class="my-1">
           <b>Please add a short description.</b><br>
           <b-form-input  v-model="leaveDescription"></b-form-input ><br>
      </b-col>
     
    </b-row>
     <b-row>
     
      <b-col md="12" class="my-1">
          <b>First Day of leave</b>
          <datetime v-model="startLeave"></datetime><br>
      </b-col>
     <b-col md="12" class="my-1">
          <b>Last Day of Leave</b>
          <datetime v-model="endLeave"></datetime><br>
      </b-col>
   
    </b-row>
     <b-row>
     
      <b-col md="12" class="my-1">
          <b>Number of Days</b>
          <b-form-input  v-model="nrDays"></b-form-input ><br>
      </b-col>
    
   
    </b-row>
     <b-row>
      <b-col md="12" class="my-1">
      <b>Select line manager to approve leave</b>
      <select class="form-control" id="id_Employee" name="Employee" style="overflow:scroll;" v-model="idLineManager">
                        <option disabled selected value="-1"> -- Select your line manager -- </option>
                        <option v-for="emp in EmployeeList"  v-bind:key="emp.idEmployee" :value="emp.idEmployee" >{{emp.employee}}</option>
					</select>  
      </b-col>
     
    </b-row>
    <br>
    <b-row>
      <b-col md="12" class="my-1">
       <input type="submit" value="Request leave " class="btn btn-primary" id="submitbtn" style="width:100%;" @click="requestLeave"/>
      </b-col>
     
    </b-row>
    </div>
    <div v-if="!createRequestVisable">
        <h3>Requesting leave ...</h3>
    </div>
    <br>
    <h3>List of my leave requests</h3><br>
    <div v-if="leaveTicketsLoaded">
    <b-table striped hover small :items="leaveTickets" :fields="fields"></b-table>
    </div>
    <div v-if="leaveToApproveTicketsLoaded">
        <h3>List of leave requests I need to approve</h3><br>
        <b-table striped hover small :items="leaveToApproveTickets" :fields="fields2">
            <template slot="show_details" slot-scope="row">
            <b-button size="sm" variant="success" @click="approveRejectLeave(1,row.item)" class="mr-2">
            Approve
            </b-button>
            <b-button size="sm" variant="danger" @click="approveRejectLeave(0,row.item)" class="mr-2">
            Reject
            </b-button>

        </template>

        </b-table>
    </div>
	
</b-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';


export default {
 
  components: {
   
   },
  data () {
    return {
      
        
      idLineManager : null,
      startLeave : null,
      endLeave : null,
      leaveDescRequired : false,
      leaveDescription : "",
      createRequestVisable : true,
      typeOfLeave : "Annual Leave",
      nrDays : 0,
      employeeDetails : null,
      EmployeeList : [],
      leaveTickets : [],
      leaveToApproveTicketsLoaded : false,
      leaveToApproveTickets : [],
      leaveTicketsLoaded : false,
      fields: {
          idTicket: {
            
            label: '#idTicket'
          },

          typeOfLeave: {
            
            label: 'Type of Leave'
          },
          TicketIssued: {
            label: 'First Day',
            sortable: false
          },
          DueDate : {
            //key: 'Last Day',
            label: 'Last Day',
            sortable: true
          },
          nrDays : {
            //key: 'Last Day',
            label: 'Number of Days'
          },
          state : {
            //key: 'Last Day',
            label: 'Status'
          },
          
          
        },
        fields2: {
          idTicket: {
            
            label: '#idTicket'
          },
            LoggedBy: {
            
            label: 'Employee'
          },

          

          typeOfLeave: {
            
            label: 'Type of Leave'
          },
          TicketIssued: {
            label: 'First Day',
            sortable: false
          },
          DueDate : {
            //key: 'Last Day',
            label: 'Last Day',
            sortable: true
          },
          nrDays : {
            //key: 'Last Day',
            label: 'Number of Days'
          },
          show_details : {
            //key: 'Last Day',
            label: 'Action Required'
          },
          
          
        }
      

    }
  },
  methods : {
      changeLastDay : function ()
      {
          console.log("changeLastDay");
          this.nrDays = moment(this.startLeave).diff(moment(this.endLeave),'days');
      },
      leaveTypeChanged : function()
      {
          if ( (this.typeOfLeave == "In Lieu")||(this.typeOfLeave == "Other"))
          {
            this.leaveDescRequired = true;

          }
          else
          {
               this.leaveDescRequired = false;
               this.leaveDescription = "";

          }
      },

    approveRejectLeave : function (approve,item)
    {
        let mainObject = this;
        let Messagetext = ""
        if ( approve == 1 )
        {
            console.log("Approve Leave");
            Messagetext = "Approve "+ item.Description.split(",")[2]+" day(s) "+item.Description.split(",")[1] +" for "+item.LoggedBy + " from "+item.TicketIssued+" to "+item.DueDate+"."
        }
        else
        {
            console.log("Reject Leave");
            Messagetext = "Reject "+ item.Description.split(",")[2]+" day(s) "+item.Description.split(",")[1] +" for "+item.LoggedBy + " from "+item.TicketIssued+" to "+item.DueDate+"."
        }

        this.$swal({
            //title: text,
            text: Messagetext,
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText:  'Cancel'
            }).then((result) => {
            if (result.value) 
            {
                console.log("Proceed");
                console.log(item);
                
                axios.get(localStorage.getItem('ticketCopURL') +'/approveRejectLeave', {
                    params: {
                        idEmployee : localStorage.getItem('idemployee'),
                        idTelegram : item.idTelegram,
                        idTicket : item.idTicket,
                        approved : approve
                       
                    },
                    headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                    })
                    .then(function (response) {
                    console.log(response);
                    if ( response.data != "Error" )
                    {
                        console.log("No problem");
                        console.log("Refresh viewLeaveToApprove");
                axios.get(localStorage.getItem('ticketCopURL') +'/viewLeaveToApprove', {
                    params: {
                        idEmployee : localStorage.getItem('idemployee'),
                    },
                    headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                    })
                    .then(function (response) {
                    console.log(response);
                    if ( response.data != "error" )
                    {
                        if ( response.data.length > 0 )
                        {
                            for( let i = 0 ; i  < response.data.length ; i++ )
                            {
                                response.data[i].typeOfLeave = response.data[i].Description.split(",")[1];
                                response.data[i].nrDays = response.data[i].Description.split(",")[2];
                                response.data[i].TicketIssued = moment(response.data[i].TicketIssued).format("YYYY-MM-DD");
                                response.data[i].DueDate = moment(response.data[i].DueDate).format("YYYY-MM-DD");
                                if (response.data[i].Resolved)
                                {
                                    response.data[i].state = response.data[i].ResolvedComment;
                                }
                                else
                                {
                                    response.data[i].state = "Awaiting approval";
                                }
                            }  
                            mainObject.leaveToApproveTickets = response.data;
                            mainObject.leaveToApproveTicketsLoaded = true; 
                        
                        }
                        else
                        {
                            mainObject.leaveToApproveTickets =[];
                            mainObject.leaveToApproveTicketsLoaded = false; 

                        }
                    }
                    

                    })
                    .catch(function (error) {
                    console.log(error);
                    })
                    .then(function () {

                    }); // end of axios call

                    }
                    else
                    {
                        console.log("Error could not approve/reject leave");
                    }
                    

                    })
                    .catch(function (error) {
                    console.log(error);
                    })
                    .then(function () {

                    }); // end of axios call
                
                // refresh list of items
                

            }
            else
            {
                console.log("Cancel");

            }
        });
       
    },

    requestLeave : function() {
        console.log("Submit");
        let mainObject = this;
        var submitobject = new Object;
        submitobject.idemployee = localStorage.getItem('idemployee');
        submitobject.employeeName = localStorage.getItem('employee');
        submitobject.TicketIssued = this.startLeave;
        submitobject.DueDate = this.endLeave;
        submitobject.idLineManager = this.idLineManager;
        submitobject.leaveDescription = this.leaveDescription;
        submitobject.nrDays = this.nrDays;
        submitobject.employeeDetails = this.employeeDetails;    
        submitobject.typeOfLeave = this.typeOfLeave;
        try{
          
        for( let i = 0 ; i < mainObject.EmployeeList.length ; i++ )
        {
            console.log(mainObject.EmployeeList[i].idEmployee);
            if (  submitobject.idLineManager == mainObject.EmployeeList[i].idEmployee )
            {

                submitobject.lineManagerDetails = mainObject.EmployeeList[i];
               
                break;
            }

           
        }
        }
        catch(e)
        {
            console.log(e);
        }
        console.log("submitobject");
        console.log(submitobject);  
        // Do validation
        let validObject = true;
        // remove quotes
        submitobject.leaveDescription = submitobject.leaveDescription.replace(/["']/g, "");
        switch ( true )
        {

            case  ( (mainObject.leaveDescRequired)&&(submitobject.leaveDescription.length > 150) )  : 
                validObject = false;
                mainObject.showAlert("Leave description must be shorter than 150 characters.",2000,false);
                break;
            case  ( (mainObject.leaveDescRequired)&&(submitobject.leaveDescription.length < 1) )  : 
                validObject = false;
                mainObject.showAlert("Please enter a description for this type of leave.",2000,false);
                break;
            case  ( (submitobject.idemployee == null) )  : 
                validObject = false;
                mainObject.showAlert("Error could not get employeeid.",2000,false);
                break;
            case   ( (submitobject.employeeName == null) ||( submitobject.employeeName == "") )  : 
                validObject = false;
                mainObject.showAlert("Error could not get employee name.",2000,false);
                break;
            case  (  moment(submitobject.TicketIssued).isAfter(moment(submitobject.DueDate)) )  : 
                validObject = false;
                mainObject.showAlert("First Day of leave cannot be after last day of leave.",2000,false);
                break;
            case  (  moment(submitobject.DueDate).isBefore(moment(submitobject.TicketIssued)) )  : 
                validObject = false;
                mainObject.showAlert("Last Day of leave cannot be ebfore first day of leave.",2000,false);
                break;
            case  (  (submitobject.nrDays < 0.5) || (submitobject.nrDays == "")  )  : 
                validObject = false;
                mainObject.showAlert("Please enter nr of day(s) leave.",2000,false);
                break;
            case  (  isNaN(submitobject.nrDays)  )  : 
                validObject = false;
                mainObject.showAlert("Please enter valid number for day(s) leave.",2000,false);
                break;

                
            case  ( (submitobject.idLineManager == null)||( submitobject.idLineManager < 1))  : 
                validObject = false;
                mainObject.showAlert("Please select your line manager.",2000,false);
                break;
            default : validObject = true;
        }
        console.log("Validation done : "+validObject);

        console.log(submitobject);
       
        if ( validObject )
        {
            let leaveMsg = "Requesting "+submitobject.nrDays+" day(s) "+submitobject.typeOfLeave+" from "+moment(submitobject.TicketIssued).format("YYYY-MM-DD")+" to "+moment(submitobject.DueDate).format("YYYY-MM-DD")+" from Line Manager "+submitobject.lineManagerDetails.employee;
           this.$swal({
            //title: text,
            text: leaveMsg,
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText:  'Cancel'
            }).then((result) => {
            if (result.value) 
            {
                console.log("Proceed");

                var authheader = "Bearer "+localStorage.getItem('jwt');
            mainObject.createRequestVisable = false;
            axios.get(localStorage.getItem('ticketCopURL') +'/createNewLeaveRequestTicket', {
                
                params : submitobject,
                headers: { "Authorization" : authheader }
                //}
            }
            )
            .then(function (response) {
                console.log(response.data);
                if ( response.data.status == "success")
                {
                    let text = "<strong>Leave was requested. You will receive an update once leave is approved.</strong>"
                    mainObject.showAlert(text,2000,false);
                    /*mainObject.$swal({
                                            title: text,
                                            text: 'Was successfully created.',
                                            type: 'info',
                                            showCancelButton: true,
                                            confirmButtonColor: '#3085d6',
                                            cancelButtonColor: '#d33',
                                            confirmButtonText: 'Click to create another Ticket',
                                            cancelButtonText:  'Return to Home'
                                            }).then((result) => {
                                            if (result.value) 
                                            {
                                                console.log("Relaod the page");
                                                //mainObject.clearAll();
                                                mainObject.$router.go()

                                            }
                                            else
                                            {
                                                 mainObject.$router.go(-1);

                                            }
                    });*/
                }
                else
                {
                    console.log("error requesting leave");
                    mainObject.showAlert("Error could not request leave at this stage.",2000,false);
                }
            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
                mainObject.createRequestVisable = true;
                console.log("Done requesting leave");
                axios.get(localStorage.getItem('ticketCopURL') +'/viewUserLeaveRequest', {
                params: {
                    idEmployee : localStorage.getItem('idemployee'),
                },
                headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                })
                .then(function (response) {
                console.log(response);
                if ( response.data != "error" )
                {
                    for( let i = 0 ; i  < response.data.length ; i++ )
                    {
                        response.data[i].typeOfLeave = response.data[i].Description.split(",")[1];
                        response.data[i].nrDays = response.data[i].Description.split(",")[2];
                        response.data[i].TicketIssued = moment(response.data[i].TicketIssued).format("YYYY-MM-DD");
                        response.data[i].DueDate = moment(response.data[i].DueDate).format("YYYY-MM-DD");
                        if (response.data[i].Resolved)
                        {
                            response.data[i].state = response.data[i].ResolvedComment;
                        }
                        else
                        {
                            response.data[i].state = "Awaiting approval";
                        }
                    }  
                    mainObject.leaveTickets = response.data;
                    mainObject.leaveTicketsLoaded = true; 
                
                }
                

                })
                .catch(function (error) {
                console.log(error);
                })
                .then(function () {

                }); // end of axios call
            })
                

            }
            else
            {
                console.log("Cancel");

            }
        }); 
            
        }
        else
        {
            console.log("Failed Validation");
        }

      },  // end of requestLeave
    showAlert : function (msg,delay,gotoprevPage)
      {
        let timerInterval;
        let mainObject = this;
        mainObject.$swal({
        //title: 'Auto close alert!',
        html: msg,
        timer: delay,
        onBeforeOpen: () => {
            mainObject.$swal.showLoading()
            timerInterval = setInterval(() => {
            mainObject.$swal.getContent().querySelector('strong')
                
            }, 100)
        },
        onClose: () => {
            clearInterval(timerInterval)
        }
        }).then((result) => {
        if (
            // Read more about handling dismissals
            result.dismiss === mainObject.$swal.DismissReason.timer
        ) {
            if ( gotoprevPage )
            mainObject.$router.go(-1);
        }
        })  
      }
  
  
  },

    watch: {
        endLeave : function()
        {
        console.log("changeLastDay");
          this.nrDays = moment(this.endLeave).diff(moment(this.startLeave),'days')+1;
          
          this.$forceUpdate(); 

        },
        startLeave : function()
        {
        console.log("changeFirstDay");
          this.nrDays = moment(this.endLeave).diff(moment(this.startLeave),'days')+1;
          //if (this.nrDays == 0 ) this.nrDays = 1;
         
           this.$forceUpdate(); 


        }

    },
  
  created : function()
  {
      let self = this;
      self.startLeave = moment().format("YYYY-MM-DD");
      self.endLeave = moment().format("YYYY-MM-DD");
      self.nrDays = 1;
      axios.get(localStorage.getItem('ticketCopURL') +'/getUsers', {
          params: {
           
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          console.log(response.data);
          self.EmployeeList = response.data.users;
          for( let i = 0 ; i < self.EmployeeList.length ; i++ )
          {
              if (  localStorage.getItem('idemployee') == self.EmployeeList[i].idEmployee )
              {
                  self.employeeDetails = self.EmployeeList[i];
                  console.log("Found Employee");
                  break;
              }
              
          }
          console.log("Details");
          console.log(self);
          
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
         
    });// end of axios call
     
      axios.get(localStorage.getItem('ticketCopURL') +'/viewUserLeaveRequest', {
          params: {
              idEmployee : localStorage.getItem('idemployee'),
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          console.log(response);
          if ( response.data != "error" )
          {
            for( let i = 0 ; i  < response.data.length ; i++ )
            {
                response.data[i].typeOfLeave = response.data[i].Description.split(",")[1];
                response.data[i].nrDays = response.data[i].Description.split(",")[2];
                response.data[i].TicketIssued = moment(response.data[i].TicketIssued).format("YYYY-MM-DD");
                response.data[i].DueDate = moment(response.data[i].DueDate).format("YYYY-MM-DD");
                if (response.data[i].Resolved)
                {
                    response.data[i].state = response.data[i].ResolvedComment;
                }
                else
                {
                    response.data[i].state = "Awaiting approval";
                }
            }  
            self.leaveTickets = response.data;
            self.leaveTicketsLoaded = true; 
          
          }
          

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {

        }); // end of axios call


    axios.get(localStorage.getItem('ticketCopURL') +'/viewLeaveToApprove', {
          params: {
              idEmployee : localStorage.getItem('idemployee'),
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          console.log(response);
          if ( response.data != "error" )
          {
            if ( response.data.length > 0 )
            {
                for( let i = 0 ; i  < response.data.length ; i++ )
                {
                    response.data[i].typeOfLeave = response.data[i].Description.split(",")[1];
                    response.data[i].nrDays = response.data[i].Description.split(",")[2];
                    response.data[i].TicketIssued = moment(response.data[i].TicketIssued).format("YYYY-MM-DD");
                    response.data[i].DueDate = moment(response.data[i].DueDate).format("YYYY-MM-DD");
                    if (response.data[i].Resolved)
                    {
                        response.data[i].state = response.data[i].ResolvedComment;
                    }
                    else
                    {
                        response.data[i].state = "Awaiting approval";
                    }
                }  
                self.leaveToApproveTickets = response.data;
                self.leaveToApproveTicketsLoaded = true; 
            
            }
          }
          

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {

        }); // end of axios call


  } // end of created
}
</script>

<!-- table-details.vue -->